import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Blog',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h(
        "g",
        {
          attrs: { fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-miterlimit": "10" }
        },
        [h("line", {
          attrs: { "stroke-width": "3", x1: "6.5", y1: "10.5", x2: "6.5", y2: "10.5" }
        }), h("line", {
          attrs: { "stroke-width": "3", x1: "12", y1: "10.5", x2: "12", y2: "10.5" }
        }), h("line", {
          attrs: { "stroke-width": "3", x1: "17.5", y1: "10.5", x2: "17.5", y2: "10.5" }
        }), h("path", {
          attrs: { d: "M19.7 2.5H4.3c-1.5 0-2.8 1.4-2.8 3.1v8.8c0 1.7 1.2 3.1 2.8 3.1h2.2v4l4-4h9.2c1.5 0 2.8-1.4 2.8-3.1V5.6c0-1.7-1.2-3.1-2.8-3.1z" }
        })]
      )]
    );
  }
};